{
  "schemaVersion": "workable.site-publication/1",
  "edition": "core",
  "sources": [
    {
      "worldId": "world:bw/product-foundation",
      "releaseId": "wr_8137e68f17239b473d1ec2226c05148391ec74678012aac48485f1b403be0b00",
      "membershipDigest": "sha256:f33318fb1bdd26f297dec2913bfeef34677e9431a9ff487404058256500364b5"
    }
  ],
  "products": {
    "authoritative": false,
    "constructs": [
      {
        "changes": [
          {
            "after": "A material signal arrives as a case: the records behind it, the assumptions and missing facts, a proposed owner and the next action. The reviewer accepts, rejects with a reason, or sends it back for more evidence.",
            "before": "An analyst opens the dashboard, finds something interesting, investigates the data, works out who should own it and builds the case by hand in a workbook.",
            "id": "decision-queue",
            "title": "From dashboards to decision queues"
          },
          {
            "after": "The question meets the current facts. The answer cites the controlling version and clause, asks for a missing fact when one changes the rule, and routes an exception to its named owner.",
            "before": "A requester searches the policy portal, reads the document and decides alone whether the rule applies to their situation.",
            "id": "answer-or-escalation",
            "title": "From search results to owned answers"
          }
        ],
        "descriptor": "Category strategy and spend system of work",
        "firstWedge": "Start with one category and one opportunity type, or one bounded policy family with a named owner. Prove that a single signal can reach an owned backlog and an accepted downstream action.",
        "functionLabel": "Category Management",
        "id": "strategy-policy-category-spend",
        "modules": [
          {
            "id": "spend-data-foundation",
            "name": "Spend data ingestion, classification and reconciliation",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "category-opportunity-radar",
            "name": "Category opportunity discovery and prioritisation",
            "sourceStanding": "pattern",
            "standing": "defined"
          },
          {
            "id": "category-strategy-orchestrator",
            "name": "Category strategy design and governance",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "policy-rule-lifecycle",
            "name": "Procurement policy rule authoring and lifecycle",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "policy-guidance",
            "name": "Procurement policy guidance",
            "sourceStanding": "pattern",
            "standing": "defined"
          }
        ],
        "name": "Radar",
        "order": 1,
        "outcome": "A live category agenda where every opportunity has an owner and a source.",
        "proofClass": "recipe",
        "proofQuestion": "Can a reviewer open one opportunity or one policy answer and trace it to its sources, its assumptions, its owner and its next action?",
        "s2pRefs": [
          "groundworks-source:domain-workblock/strategy-policy-category-spend"
        ],
        "signature": "WORKABLE Radar",
        "signatureStanding": "proposed",
        "slug": "radar",
        "summary": "Turn spend and market signals into category decisions, policy answers and an executable opportunity backlog."
      },
      {
        "changes": [
          {
            "after": "The route arrives as a proposal: the policy cited, the source facts with their freshness, what is missing, the alternatives considered and the named owner who accepts or corrects it.",
            "before": "A form or chat captures the request. An analyst still rebuilds the case by hand across policy, contracts, suppliers, budget and prior requests before anyone can route it.",
            "id": "decision-package",
            "title": "Routing becomes a decision package"
          },
          {
            "after": "One parent plan links each specialist's record. A failed step shows as blocked with an owner. The parent cannot report complete while material child work stays open.",
            "before": "One request becomes four queue entries. Procurement, legal, risk and buying each track their own piece, and nobody can say when the whole thing is done.",
            "id": "parent-outcome",
            "title": "One parent outcome"
          }
        ],
        "descriptor": "Intake and demand system of work",
        "firstWedge": "Start with one non-catalogue request family that is returned or rerouted today: several owners, a measurable baseline and one downstream action that can be tested safely.",
        "functionLabel": "Intake Management",
        "id": "intake-demand",
        "modules": [
          {
            "id": "procurement-service-catalogue",
            "name": "Procurement service catalogue",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "intelligent-intake",
            "name": "Procurement request intake",
            "sourceStanding": "reference",
            "standing": "reference"
          },
          {
            "id": "request-enrichment-routing",
            "name": "Procurement request enrichment and routing",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "demand-orchestration",
            "name": "Procurement request coordination",
            "sourceStanding": "pattern",
            "standing": "defined"
          },
          {
            "id": "demand-consolidation-portfolio",
            "name": "Demand consolidation and portfolio planning",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          }
        ],
        "name": "Gateway",
        "order": 2,
        "outcome": "Every request arrives complete, routed and owned, without manual triage.",
        "proofClass": "demo-workblock",
        "proofQuestion": "Does the front door ask only for the facts it cannot find, explain the route it proposes and keep the owner and state visible after the handoff?",
        "s2pRefs": [
          "groundworks-source:domain-workblock/intake-demand"
        ],
        "signature": "WORKABLE Gateway",
        "signatureStanding": "proposed",
        "slug": "gateway",
        "summary": "Give every request a guided front door, gather the facts that decide its route and hand it to the right policy, person or Workblock."
      },
      {
        "changes": [
          {
            "after": "The recommendation reaches the award authority as one package: scores, responses, risk inputs, dissent and conditions, each opening to its source.",
            "before": "The suite closes the event; analysts rebuild the decision in workbooks, inboxes and a pre-award meeting.",
            "id": "assembled-award",
            "title": "The award review arrives assembled"
          },
          {
            "after": "Each proposed move carries its limit, its approver and its expiry. A move outside authority is blocked and routed for a bounded decision.",
            "before": "What a negotiator may offer lives in a delegation memo and in memory, and a persuasive recommendation can read like an authorised position.",
            "id": "authority-line",
            "title": "Advice stops at the authority line"
          }
        ],
        "descriptor": "Sourcing and negotiation system of work",
        "firstWedge": "Start with one category's path from closed responses to an approved award, where preparation and evaluation carry a measurable burden today. The suite keeps the event and the bid record; nothing migrates.",
        "functionLabel": "Sourcing & Negotiation",
        "id": "sourcing-negotiation",
        "modules": [
          {
            "id": "sourcing-pipeline-discovery",
            "name": "Sourcing pipeline discovery",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "sourcing-event",
            "name": "Sourcing event preparation and evaluation",
            "sourceStanding": "reference",
            "standing": "reference"
          },
          {
            "id": "bid-evaluation-award",
            "name": "Bid evaluation and award preparation",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "negotiation-copilot",
            "name": "Negotiation preparation",
            "sourceStanding": "pattern",
            "standing": "defined"
          },
          {
            "id": "tactical-sourcing-autonomy",
            "name": "Policy-bounded tactical sourcing execution",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          }
        ],
        "name": "Dealroom",
        "order": 3,
        "outcome": "Sourcing decisions you can defend line by line: every score opens the response behind it.",
        "proofClass": "demo-workblock",
        "proofQuestion": "Can the award authority trace every criterion, score and recommendation to the response and rule behind it, without a pack built by hand?",
        "s2pRefs": [
          "groundworks-source:domain-workblock/sourcing-negotiation"
        ],
        "signature": "WORKABLE Dealroom",
        "signatureStanding": "proposed",
        "slug": "dealroom",
        "summary": "Shape events, analyse responses and prepare negotiation positions with named decision rights at every award step."
      },
      {
        "changes": [
          {
            "after": "Each material clause arrives as a decision: the exact language, the position it departs from, the options and the reviewer whose authority it needs, with uncertainty stated rather than smoothed over.",
            "before": "A contract is uploaded and a long machine summary comes back: risks, observations and suggested language, hard to verify and structured around nothing in particular.",
            "id": "review-decisions",
            "title": "Findings become decisions"
          },
          {
            "after": "Executed language becomes owned cases. A renewal arrives as a decision with the clause, the notice deadline, the performance history and a named owner, before the window closes.",
            "before": "Executed contracts sit in a repository with reminders. A notification says a contract is about to expire; someone rereads it, works out what it means and chases the owner.",
            "id": "active-obligations",
            "title": "From repository to active obligations"
          }
        ],
        "descriptor": "Contract lifecycle system of work",
        "firstWedge": "Start with one contract family and one decision boundary: third-party paper taken to accepted positions, or one material obligation class taken to accepted closure.",
        "functionLabel": "Contract Lifecycle Management (CLM)",
        "id": "contract-lifecycle-management",
        "modules": [
          {
            "id": "contract-intake-digitization",
            "name": "Contract data capture and extraction",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "contract-authoring-review",
            "name": "Contract drafting, negotiation and redlining",
            "sourceStanding": "reference",
            "standing": "reference"
          },
          {
            "id": "contract-approval-repository",
            "name": "Contract approval, execution and storage",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "obligation-monitoring",
            "name": "Obligation and performance management",
            "sourceStanding": "pattern",
            "standing": "defined"
          },
          {
            "id": "renewal-change-compliance",
            "name": "Renewal, change and compliance",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          }
        ],
        "name": "Accord",
        "order": 4,
        "outcome": "Every clause, control and obligation stays attached to its contract, with a named owner for each one.",
        "proofClass": "demo-workblock",
        "proofQuestion": "Can one contract be traced from proposed language through human acceptance to the action that followed, with the native document intact and every finding opening the exact language behind it?",
        "s2pRefs": [
          "groundworks-source:domain-workblock/contract-lifecycle-management"
        ],
        "signature": "WORKABLE Accord",
        "signatureStanding": "proposed",
        "slug": "accord",
        "summary": "Draft, review, approve and monitor contracts while preserving native document fidelity and human legal authority."
      },
      {
        "changes": [
          {
            "after": "The case opens with what the organisation already holds, the supplier is asked only for what the decision still needs, and only material exceptions reach a named owner.",
            "before": "Every supplier receives the full questionnaire pack, teams chase documents by email, and reviewers work through the same approval steps regardless of risk.",
            "id": "assembled-case",
            "title": "From forms and chasing to an assembled case"
          },
          {
            "after": "A signal is matched to the party and engagement, tested for materiality, and arrives as a case carrying the supporting evidence, the prior decision it affects and a named decision owner.",
            "before": "Monitoring produces scores, news alerts and colour ratings, and someone must work out whether each event is real, material and theirs to act on.",
            "id": "managed-exceptions",
            "title": "From risk alerts to managed exceptions"
          }
        ],
        "descriptor": "Supplier lifecycle and third-party risk system of work",
        "firstWedge": "Start with one supplier or risk tier where the evidence rules are stable and the exceptions repeat, and prove one measured handoff into the supplier master or GRC system you already run.",
        "functionLabel": "Supplier & Third-Party Risk Management (TPRM)",
        "id": "supplier-lifecycle-third-party-risk",
        "modules": [
          {
            "id": "supplier-onboarding",
            "name": "Supplier onboarding",
            "sourceStanding": "reference",
            "standing": "reference"
          },
          {
            "id": "supplier-master-qualification",
            "name": "Supplier master data and qualification",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "third-party-risk-review",
            "name": "Third-party risk review",
            "sourceStanding": "reference",
            "standing": "reference"
          },
          {
            "id": "continuous-risk-monitoring",
            "name": "Third-party risk signal tracking",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "supplier-remediation-exit",
            "name": "Supplier remediation and exit coordination",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          }
        ],
        "name": "Sentinel",
        "order": 5,
        "outcome": "Every risk decision has an owner, a case file and a proportionate response.",
        "proofClass": "demo-workblock",
        "proofQuestion": "Does the case reuse facts already verified, show which evidence is current and which conflicts, and reserve residual-risk acceptance for the named owner?",
        "s2pRefs": [
          "groundworks-source:domain-workblock/supplier-lifecycle-third-party-risk"
        ],
        "signature": "WORKABLE Sentinel",
        "signatureStanding": "proposed",
        "slug": "sentinel",
        "summary": "Coordinate onboarding, evidence collection, risk review, remediation and periodic reassessment around one supplier record."
      },
      {
        "changes": [
          {
            "after": "The exception arrives as one case: the affected order version, the evidence for its cause, the owner, the authority each option needs and the next valid action. It closes when the owning system shows the corrected state, not when a retry is sent.",
            "before": "A failed order raises an error code in a worklist. The resolver opens each related system, works out the cause by hand and closes the ticket once a retry is sent.",
            "id": "exception",
            "title": "The exception arrives as a case"
          },
          {
            "after": "Demand that matches an approved category, supplier and budget moves on the policy's authority, with the full record kept. People see the cases that carry an exception, missing evidence or material spend, and an exception can never quietly become routine.",
            "before": "Every request walks the same approval chain, so approvers clear queues of routine requests while the exceptional ones wait in the same line.",
            "id": "graduated-attention",
            "title": "Attention follows materiality"
          }
        ],
        "descriptor": "Buying and ordering system of work",
        "firstWedge": "Start with one recurring purchase-order exception: a cause that returns every week, with named owners and a way to confirm the corrected state in the system that owns the order. Lead with guided buying only where one demand class keeps missing its route after the configured path has been examined.",
        "functionLabel": "Purchasing & Ordering",
        "id": "buying-ordering-receiving",
        "modules": [
          {
            "id": "guided-buying",
            "name": "Guided buying",
            "sourceStanding": "pattern",
            "standing": "defined"
          },
          {
            "id": "requisition-policy-routing",
            "name": "Requisition policy evaluation and routing",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "purchase-order-orchestration",
            "name": "Purchase order orchestration",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "purchase-order-exception",
            "name": "Purchase order exception resolution",
            "sourceStanding": "pattern",
            "standing": "defined"
          },
          {
            "id": "receiving-service-entry",
            "name": "Goods receipt and service-entry coordination",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          }
        ],
        "name": "Buyline",
        "order": 6,
        "outcome": "The compliant route is the easiest one, and every exception reaches a named owner.",
        "proofClass": "recipe",
        "proofQuestion": "Can a stated need reach the valid buying route, with the reason visible, while the ERP keeps every transaction?",
        "s2pRefs": [
          "groundworks-source:domain-workblock/buying-ordering-receiving"
        ],
        "signature": "WORKABLE Buyline",
        "signatureStanding": "proposed",
        "slug": "buyline",
        "summary": "Guide compliant buying, resolve purchase-order exceptions and keep ERP execution aligned with policy."
      },
      {
        "changes": [
          {
            "after": "The failed check arrives as one case: the competing causes, the evidence that separates them, the accountable owner and the next valid action. The case closes only when the source system accepts the change and reruns the check.",
            "before": "A failed check lands in a worklist as a code that names the symptom. The processor works out the cause and the owner by hand, one system at a time.",
            "id": "causal-case",
            "title": "From queue codes to causal cases"
          },
          {
            "after": "Every release condition names its source and observation time. A material change expires the proposal and reopens only the affected checks. The payment system keeps final release control.",
            "before": "A payment candidate shows eligible. The approval was granted days ago, and the payee record, a hold or a screening result may have changed since.",
            "id": "dated-readiness",
            "title": "From a status badge to a dated decision"
          }
        ],
        "descriptor": "Invoice and payment readiness system of work",
        "firstWedge": "Start with one high-volume exception reason with a stable source rule and a named owner, such as a receipt or price mismatch, or one bounded pre-release gate where the evidence spans more than one system. Payment execution stays out of scope.",
        "functionLabel": "Invoicing & Payment (AP)",
        "id": "invoice-exception-payment-readiness",
        "modules": [
          {
            "id": "invoice-exception-triage",
            "name": "Invoice exception triage",
            "sourceStanding": "reference",
            "standing": "reference"
          },
          {
            "id": "payment-readiness",
            "name": "Payment readiness check",
            "sourceStanding": "pattern",
            "standing": "defined"
          },
          {
            "id": "invoice-intake-match",
            "name": "Invoice intake and matching",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "supplier-invoice-resolution",
            "name": "Supplier invoice resolution",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "payment-execution-guard",
            "name": "Payment execution control",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          }
        ],
        "name": "Clearway",
        "order": 7,
        "outcome": "A payment queue where every exception carries its records and its owner.",
        "proofClass": "demo-workblock",
        "proofQuestion": "Can one case show the causal evidence, the blockers, the owner and the next valid action, while the payment rail stays untouched?",
        "s2pRefs": [
          "groundworks-source:domain-workblock/invoice-exception-payment-readiness"
        ],
        "signature": "WORKABLE Clearway",
        "signatureStanding": "proposed",
        "slug": "clearway",
        "summary": "Classify invoice exceptions, collect the missing records and prepare decisions before payment execution."
      },
      {
        "changes": [
          {
            "after": "The review arrives as a decision package: every score opens into its method, sources and freshness, critical exceptions sit beside the average, and the proposed conclusion waits for the owner to accept, edit or reject it.",
            "before": "An analyst reconciles extracts into a workbook, the relationship manager builds a deck, and the reviewer still hunts for the source behind every disputed number.",
            "id": "decision-package",
            "title": "From scorecard to decision package"
          },
          {
            "after": "An action stays proposed until the responsible buyer or supplier owner accepts it. Closed means a named reviewer accepted the closure evidence; weak evidence reopens the action instead of erasing its history.",
            "before": "Actions live in minutes, decks and email threads. Done means someone ticked a task, and the next review starts by reconstructing what happened.",
            "id": "accepted-commitments",
            "title": "From minuted actions to accepted commitments"
          }
        ],
        "descriptor": "Supplier performance and innovation system of work",
        "firstWedge": "Start with one strategic supplier review cycle: one with heavy preparation, disputed evidence or actions that keep losing their owners.",
        "functionLabel": "Supplier Relationship Management (SRM)",
        "id": "supplier-performance-innovation-relationship",
        "modules": [
          {
            "id": "supplier-performance-review",
            "name": "Supplier performance review",
            "sourceStanding": "reference",
            "standing": "reference"
          },
          {
            "id": "supplier-innovation-pipeline",
            "name": "Supplier innovation pipeline",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "supplier-segmentation-governance",
            "name": "Supplier segmentation and governance",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "supplier-performance-monitor-correct",
            "name": "Supplier performance tracking and corrective action",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "supplier-relationship-joint-value",
            "name": "Supplier relationship and joint-value planning",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          }
        ],
        "name": "Alliance",
        "order": 8,
        "outcome": "Reviews end in commitments someone accepted, and the next review starts from what happened to them.",
        "proofClass": "demo-workblock",
        "proofQuestion": "Can one review finding be traced from its source evidence to an accepted commitment, its owner and the evidence that closed it?",
        "s2pRefs": [
          "groundworks-source:domain-workblock/supplier-performance-innovation-relationship"
        ],
        "signature": "WORKABLE Alliance",
        "signatureStanding": "proposed",
        "slug": "alliance",
        "summary": "Bring scorecards, actions, reviews and innovation opportunities into one accountable supplier rhythm."
      },
      {
        "changes": [
          {
            "after": "Every number opens the initiative behind it: source records, approved method, owner and current state. A challenged claim is answered from the case, not reassembled for the meeting.",
            "before": "A report shows pipeline, forecast and realised value. When finance challenges a number, an analyst rebuilds the calculation in a workbook and the meeting decides.",
            "id": "worked-case",
            "title": "From the savings report to the worked case"
          },
          {
            "after": "A material variance becomes one case that tests the normal explanations first, names the accountable owner, and stays open until the owning system accepts the action and the result is remeasured.",
            "before": "A dashboard flags a shortfall. Teams debate timing, volume, currency and adoption by email, and the action lands in another system with no link back to the case.",
            "id": "causal-case",
            "title": "From variance alerts to a causal case"
          }
        ],
        "descriptor": "Value realisation and savings system of work",
        "firstWedge": "Start with one initiative class where finance has already agreed the baseline and the recognition rule, and the actuals arrive from stable sources. Keep the planning, analytics and finance systems that hold authority today.",
        "functionLabel": "Savings & Value Realisation",
        "id": "value-realization-savings",
        "modules": [
          {
            "id": "savings-initiative",
            "name": "Savings initiative tracking",
            "sourceStanding": "reference",
            "standing": "reference"
          },
          {
            "id": "value-leakage-monitor",
            "name": "Value leakage monitoring",
            "sourceStanding": "pattern",
            "standing": "defined"
          },
          {
            "id": "value-opportunity-baseline",
            "name": "Value opportunity and baseline definition",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "realization-reconciliation-attribution",
            "name": "Value realisation reconciliation and attribution",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          },
          {
            "id": "value-portfolio-forecast",
            "name": "Value portfolio forecasting",
            "sourceStanding": "roadmap",
            "standing": "roadmap"
          }
        ],
        "name": "Value Hunter",
        "order": 9,
        "outcome": "A savings number finance can trace to the records that produced it.",
        "proofClass": "demo-workblock",
        "proofQuestion": "Can a reviewer tell why a number is pipeline, forecast or validated realisation, and open the initiatives and source records behind it?",
        "s2pRefs": [
          "groundworks-source:domain-workblock/value-realization-savings"
        ],
        "signature": "WORKABLE Value Hunter",
        "signatureStanding": "proposed",
        "slug": "value-hunter",
        "summary": "Connect opportunities, initiatives, forecasts, validation and leakage to the records that explain the number."
      }
    ],
    "disclosure": "public",
    "kind": "publication-content",
    "lifecycle": {
      "construct": "A Construct is the managed source of one product: its job and result, how the work happens and the standard it must meet.",
      "workblock": "A Workblock is the executable enterprise app assembled from a Construct, running under platform controls.",
      "world": "A World holds governed domain meaning: the Source-to-Pay identities, rules, evidence requirements and roles every product composes."
    },
    "moduleTotals": {
      "defined": 9,
      "reference": 8,
      "roadmap": 28
    },
    "ownerWorldId": "world:bw/product-foundation",
    "product": "WORKABLE",
    "proofClassRule": "demo-workblock when the Construct has at least one reference module; otherwise recipe. No Construct is claimed as a configured deployment or production evidence.",
    "schemaVersion": "workable.product-map/1",
    "sources": [
      {
        "commit": "20566e2824ffbca9527ceab6cfb6c19bb689d9a3",
        "path": "framework/generated/accenture-site.snapshot.json",
        "repository": "bwllaming/GroundWorks",
        "use": "domain Workblocks, module names and implementationStatus"
      },
      {
        "commit": "c33327a0275623483a38c9c874e525499f814494",
        "path": "workable/html/website/assets/portfolio.json",
        "repository": "bwllaming/brand-and-design",
        "use": "WORKABLE signatures, purpose, outcome, wedge, proof question, changes"
      }
    ],
    "standing": "proposed",
    "standingVocabulary": {
      "defined": "Business, data, authority and execution contracts are defined for client configuration. Source term: pattern.",
      "reference": "Demonstrable on the execution rails at the source's confirmed fidelity. Not proof of a customer deployment.",
      "roadmap": "Planned and not represented as running."
    },
    "worldId": "world:bw/product-foundation"
  },
  "expression": {
    "assets": [],
    "audience": "partner",
    "disclosure": "public",
    "edition": "core",
    "footer": {
      "credit": "A Beyond Labs release. Part of the Beyond Work family.",
      "tagline": "Goals. Realized."
    },
    "hero": {
      "creditLine": "A Beyond Labs release.",
      "eyebrow": "WORKABLE Core",
      "headline": "Build enterprise products\naround the work.",
      "lede": "WORKABLE is the product base partners use to deliver S2P enterprise apps. Nine Constructs. One shared model. Inspectable standing per module.",
      "primaryCta": {
        "href": "/accenture-edition",
        "label": "Build an edition"
      },
      "secondaryCta": {
        "href": "/constructs/value-hunter",
        "label": "See Value Hunter"
      }
    },
    "kind": "publication-content",
    "ownerWorldId": "world:bw/product-foundation",
    "product": "WORKABLE Core",
    "routes": {
      "constructDetail": "/constructs/:slug",
      "constructs": "/constructs",
      "root": "/"
    },
    "schemaVersion": "workable.site-expression/1",
    "sections": [
      {
        "body": "An edition changes more than the visual theme. It brings a named method into the work.",
        "id": "what-partners-get",
        "items": [
          {
            "body": "Nine stable product identities with defined behavior, evidence requirements and decision rules. You apply your method on top, not around them.",
            "id": "governed-constructs",
            "title": "Governed Constructs you adapt without forking."
          },
          {
            "body": "Take Core and contribute your method, vocabulary, roles and delivery knowledge. The Accenture Edition is the first published example.",
            "id": "edition-path",
            "title": "An edition path for your method and brand."
          },
          {
            "body": "Supplier, Contract, PurchaseOrder, Invoice and every domain relationship traced to one World. Configure for each client without owning the meaning.",
            "id": "shared-s2p-model",
            "title": "A shared S2P domain model."
          },
          {
            "body": "Each of the 45 Business modules carries its source standing: Reference, Defined or Roadmap. You see what is demonstrable and what is planned before you commit.",
            "id": "provable-standing",
            "title": "Provable standing per module."
          }
        ],
        "title": "The partner advantage."
      },
      {
        "body": "WORKABLE is built from a chain of governed sources, not from one application build.",
        "id": "lifecycle",
        "title": "World → Construct → Workblock."
      },
      {
        "body": "Each product covers one S2P responsibility and five Business modules at their actual source standing.",
        "id": "constructs",
        "standingLabels": {
          "defined": "Defined",
          "reference": "Demonstrable",
          "roadmap": "Roadmap"
        },
        "title": "Nine products. One model."
      },
      {
        "body": "Core is the shared foundation. A partner edition adds method, vocabulary, delivery knowledge and the partner's own brand. The Accenture Edition is the live example.",
        "cta": {
          "href": "/accenture-edition",
          "label": "See the Accenture Edition"
        },
        "id": "editions",
        "title": "Partners adapt Core without forking it."
      }
    ],
    "standing": "proposed",
    "worldId": "world:bw/product-foundation"
  },
  "items": [
    {
      "id": "workable-product-map",
      "sourceWorldId": "world:bw/product-foundation",
      "releaseId": "wr_8137e68f17239b473d1ec2226c05148391ec74678012aac48485f1b403be0b00",
      "entityId": "workable-product-map",
      "contentDigest": "sha256:ab45aa116eb2ad26ba8452f6071ddfc2878689c001ad8448a6daa3cce8d147b5",
      "disclosure": "public",
      "body": {
        "authoritative": false,
        "constructs": [
          {
            "changes": [
              {
                "after": "A material signal arrives as a case: the records behind it, the assumptions and missing facts, a proposed owner and the next action. The reviewer accepts, rejects with a reason, or sends it back for more evidence.",
                "before": "An analyst opens the dashboard, finds something interesting, investigates the data, works out who should own it and builds the case by hand in a workbook.",
                "id": "decision-queue",
                "title": "From dashboards to decision queues"
              },
              {
                "after": "The question meets the current facts. The answer cites the controlling version and clause, asks for a missing fact when one changes the rule, and routes an exception to its named owner.",
                "before": "A requester searches the policy portal, reads the document and decides alone whether the rule applies to their situation.",
                "id": "answer-or-escalation",
                "title": "From search results to owned answers"
              }
            ],
            "descriptor": "Category strategy and spend system of work",
            "firstWedge": "Start with one category and one opportunity type, or one bounded policy family with a named owner. Prove that a single signal can reach an owned backlog and an accepted downstream action.",
            "functionLabel": "Category Management",
            "id": "strategy-policy-category-spend",
            "modules": [
              {
                "id": "spend-data-foundation",
                "name": "Spend data ingestion, classification and reconciliation",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "category-opportunity-radar",
                "name": "Category opportunity discovery and prioritisation",
                "sourceStanding": "pattern",
                "standing": "defined"
              },
              {
                "id": "category-strategy-orchestrator",
                "name": "Category strategy design and governance",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "policy-rule-lifecycle",
                "name": "Procurement policy rule authoring and lifecycle",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "policy-guidance",
                "name": "Procurement policy guidance",
                "sourceStanding": "pattern",
                "standing": "defined"
              }
            ],
            "name": "Radar",
            "order": 1,
            "outcome": "A live category agenda where every opportunity has an owner and a source.",
            "proofClass": "recipe",
            "proofQuestion": "Can a reviewer open one opportunity or one policy answer and trace it to its sources, its assumptions, its owner and its next action?",
            "s2pRefs": [
              "groundworks-source:domain-workblock/strategy-policy-category-spend"
            ],
            "signature": "WORKABLE Radar",
            "signatureStanding": "proposed",
            "slug": "radar",
            "summary": "Turn spend and market signals into category decisions, policy answers and an executable opportunity backlog."
          },
          {
            "changes": [
              {
                "after": "The route arrives as a proposal: the policy cited, the source facts with their freshness, what is missing, the alternatives considered and the named owner who accepts or corrects it.",
                "before": "A form or chat captures the request. An analyst still rebuilds the case by hand across policy, contracts, suppliers, budget and prior requests before anyone can route it.",
                "id": "decision-package",
                "title": "Routing becomes a decision package"
              },
              {
                "after": "One parent plan links each specialist's record. A failed step shows as blocked with an owner. The parent cannot report complete while material child work stays open.",
                "before": "One request becomes four queue entries. Procurement, legal, risk and buying each track their own piece, and nobody can say when the whole thing is done.",
                "id": "parent-outcome",
                "title": "One parent outcome"
              }
            ],
            "descriptor": "Intake and demand system of work",
            "firstWedge": "Start with one non-catalogue request family that is returned or rerouted today: several owners, a measurable baseline and one downstream action that can be tested safely.",
            "functionLabel": "Intake Management",
            "id": "intake-demand",
            "modules": [
              {
                "id": "procurement-service-catalogue",
                "name": "Procurement service catalogue",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "intelligent-intake",
                "name": "Procurement request intake",
                "sourceStanding": "reference",
                "standing": "reference"
              },
              {
                "id": "request-enrichment-routing",
                "name": "Procurement request enrichment and routing",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "demand-orchestration",
                "name": "Procurement request coordination",
                "sourceStanding": "pattern",
                "standing": "defined"
              },
              {
                "id": "demand-consolidation-portfolio",
                "name": "Demand consolidation and portfolio planning",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              }
            ],
            "name": "Gateway",
            "order": 2,
            "outcome": "Every request arrives complete, routed and owned, without manual triage.",
            "proofClass": "demo-workblock",
            "proofQuestion": "Does the front door ask only for the facts it cannot find, explain the route it proposes and keep the owner and state visible after the handoff?",
            "s2pRefs": [
              "groundworks-source:domain-workblock/intake-demand"
            ],
            "signature": "WORKABLE Gateway",
            "signatureStanding": "proposed",
            "slug": "gateway",
            "summary": "Give every request a guided front door, gather the facts that decide its route and hand it to the right policy, person or Workblock."
          },
          {
            "changes": [
              {
                "after": "The recommendation reaches the award authority as one package: scores, responses, risk inputs, dissent and conditions, each opening to its source.",
                "before": "The suite closes the event; analysts rebuild the decision in workbooks, inboxes and a pre-award meeting.",
                "id": "assembled-award",
                "title": "The award review arrives assembled"
              },
              {
                "after": "Each proposed move carries its limit, its approver and its expiry. A move outside authority is blocked and routed for a bounded decision.",
                "before": "What a negotiator may offer lives in a delegation memo and in memory, and a persuasive recommendation can read like an authorised position.",
                "id": "authority-line",
                "title": "Advice stops at the authority line"
              }
            ],
            "descriptor": "Sourcing and negotiation system of work",
            "firstWedge": "Start with one category's path from closed responses to an approved award, where preparation and evaluation carry a measurable burden today. The suite keeps the event and the bid record; nothing migrates.",
            "functionLabel": "Sourcing & Negotiation",
            "id": "sourcing-negotiation",
            "modules": [
              {
                "id": "sourcing-pipeline-discovery",
                "name": "Sourcing pipeline discovery",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "sourcing-event",
                "name": "Sourcing event preparation and evaluation",
                "sourceStanding": "reference",
                "standing": "reference"
              },
              {
                "id": "bid-evaluation-award",
                "name": "Bid evaluation and award preparation",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "negotiation-copilot",
                "name": "Negotiation preparation",
                "sourceStanding": "pattern",
                "standing": "defined"
              },
              {
                "id": "tactical-sourcing-autonomy",
                "name": "Policy-bounded tactical sourcing execution",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              }
            ],
            "name": "Dealroom",
            "order": 3,
            "outcome": "Sourcing decisions you can defend line by line: every score opens the response behind it.",
            "proofClass": "demo-workblock",
            "proofQuestion": "Can the award authority trace every criterion, score and recommendation to the response and rule behind it, without a pack built by hand?",
            "s2pRefs": [
              "groundworks-source:domain-workblock/sourcing-negotiation"
            ],
            "signature": "WORKABLE Dealroom",
            "signatureStanding": "proposed",
            "slug": "dealroom",
            "summary": "Shape events, analyse responses and prepare negotiation positions with named decision rights at every award step."
          },
          {
            "changes": [
              {
                "after": "Each material clause arrives as a decision: the exact language, the position it departs from, the options and the reviewer whose authority it needs, with uncertainty stated rather than smoothed over.",
                "before": "A contract is uploaded and a long machine summary comes back: risks, observations and suggested language, hard to verify and structured around nothing in particular.",
                "id": "review-decisions",
                "title": "Findings become decisions"
              },
              {
                "after": "Executed language becomes owned cases. A renewal arrives as a decision with the clause, the notice deadline, the performance history and a named owner, before the window closes.",
                "before": "Executed contracts sit in a repository with reminders. A notification says a contract is about to expire; someone rereads it, works out what it means and chases the owner.",
                "id": "active-obligations",
                "title": "From repository to active obligations"
              }
            ],
            "descriptor": "Contract lifecycle system of work",
            "firstWedge": "Start with one contract family and one decision boundary: third-party paper taken to accepted positions, or one material obligation class taken to accepted closure.",
            "functionLabel": "Contract Lifecycle Management (CLM)",
            "id": "contract-lifecycle-management",
            "modules": [
              {
                "id": "contract-intake-digitization",
                "name": "Contract data capture and extraction",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "contract-authoring-review",
                "name": "Contract drafting, negotiation and redlining",
                "sourceStanding": "reference",
                "standing": "reference"
              },
              {
                "id": "contract-approval-repository",
                "name": "Contract approval, execution and storage",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "obligation-monitoring",
                "name": "Obligation and performance management",
                "sourceStanding": "pattern",
                "standing": "defined"
              },
              {
                "id": "renewal-change-compliance",
                "name": "Renewal, change and compliance",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              }
            ],
            "name": "Accord",
            "order": 4,
            "outcome": "Every clause, control and obligation stays attached to its contract, with a named owner for each one.",
            "proofClass": "demo-workblock",
            "proofQuestion": "Can one contract be traced from proposed language through human acceptance to the action that followed, with the native document intact and every finding opening the exact language behind it?",
            "s2pRefs": [
              "groundworks-source:domain-workblock/contract-lifecycle-management"
            ],
            "signature": "WORKABLE Accord",
            "signatureStanding": "proposed",
            "slug": "accord",
            "summary": "Draft, review, approve and monitor contracts while preserving native document fidelity and human legal authority."
          },
          {
            "changes": [
              {
                "after": "The case opens with what the organisation already holds, the supplier is asked only for what the decision still needs, and only material exceptions reach a named owner.",
                "before": "Every supplier receives the full questionnaire pack, teams chase documents by email, and reviewers work through the same approval steps regardless of risk.",
                "id": "assembled-case",
                "title": "From forms and chasing to an assembled case"
              },
              {
                "after": "A signal is matched to the party and engagement, tested for materiality, and arrives as a case carrying the supporting evidence, the prior decision it affects and a named decision owner.",
                "before": "Monitoring produces scores, news alerts and colour ratings, and someone must work out whether each event is real, material and theirs to act on.",
                "id": "managed-exceptions",
                "title": "From risk alerts to managed exceptions"
              }
            ],
            "descriptor": "Supplier lifecycle and third-party risk system of work",
            "firstWedge": "Start with one supplier or risk tier where the evidence rules are stable and the exceptions repeat, and prove one measured handoff into the supplier master or GRC system you already run.",
            "functionLabel": "Supplier & Third-Party Risk Management (TPRM)",
            "id": "supplier-lifecycle-third-party-risk",
            "modules": [
              {
                "id": "supplier-onboarding",
                "name": "Supplier onboarding",
                "sourceStanding": "reference",
                "standing": "reference"
              },
              {
                "id": "supplier-master-qualification",
                "name": "Supplier master data and qualification",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "third-party-risk-review",
                "name": "Third-party risk review",
                "sourceStanding": "reference",
                "standing": "reference"
              },
              {
                "id": "continuous-risk-monitoring",
                "name": "Third-party risk signal tracking",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "supplier-remediation-exit",
                "name": "Supplier remediation and exit coordination",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              }
            ],
            "name": "Sentinel",
            "order": 5,
            "outcome": "Every risk decision has an owner, a case file and a proportionate response.",
            "proofClass": "demo-workblock",
            "proofQuestion": "Does the case reuse facts already verified, show which evidence is current and which conflicts, and reserve residual-risk acceptance for the named owner?",
            "s2pRefs": [
              "groundworks-source:domain-workblock/supplier-lifecycle-third-party-risk"
            ],
            "signature": "WORKABLE Sentinel",
            "signatureStanding": "proposed",
            "slug": "sentinel",
            "summary": "Coordinate onboarding, evidence collection, risk review, remediation and periodic reassessment around one supplier record."
          },
          {
            "changes": [
              {
                "after": "The exception arrives as one case: the affected order version, the evidence for its cause, the owner, the authority each option needs and the next valid action. It closes when the owning system shows the corrected state, not when a retry is sent.",
                "before": "A failed order raises an error code in a worklist. The resolver opens each related system, works out the cause by hand and closes the ticket once a retry is sent.",
                "id": "exception",
                "title": "The exception arrives as a case"
              },
              {
                "after": "Demand that matches an approved category, supplier and budget moves on the policy's authority, with the full record kept. People see the cases that carry an exception, missing evidence or material spend, and an exception can never quietly become routine.",
                "before": "Every request walks the same approval chain, so approvers clear queues of routine requests while the exceptional ones wait in the same line.",
                "id": "graduated-attention",
                "title": "Attention follows materiality"
              }
            ],
            "descriptor": "Buying and ordering system of work",
            "firstWedge": "Start with one recurring purchase-order exception: a cause that returns every week, with named owners and a way to confirm the corrected state in the system that owns the order. Lead with guided buying only where one demand class keeps missing its route after the configured path has been examined.",
            "functionLabel": "Purchasing & Ordering",
            "id": "buying-ordering-receiving",
            "modules": [
              {
                "id": "guided-buying",
                "name": "Guided buying",
                "sourceStanding": "pattern",
                "standing": "defined"
              },
              {
                "id": "requisition-policy-routing",
                "name": "Requisition policy evaluation and routing",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "purchase-order-orchestration",
                "name": "Purchase order orchestration",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "purchase-order-exception",
                "name": "Purchase order exception resolution",
                "sourceStanding": "pattern",
                "standing": "defined"
              },
              {
                "id": "receiving-service-entry",
                "name": "Goods receipt and service-entry coordination",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              }
            ],
            "name": "Buyline",
            "order": 6,
            "outcome": "The compliant route is the easiest one, and every exception reaches a named owner.",
            "proofClass": "recipe",
            "proofQuestion": "Can a stated need reach the valid buying route, with the reason visible, while the ERP keeps every transaction?",
            "s2pRefs": [
              "groundworks-source:domain-workblock/buying-ordering-receiving"
            ],
            "signature": "WORKABLE Buyline",
            "signatureStanding": "proposed",
            "slug": "buyline",
            "summary": "Guide compliant buying, resolve purchase-order exceptions and keep ERP execution aligned with policy."
          },
          {
            "changes": [
              {
                "after": "The failed check arrives as one case: the competing causes, the evidence that separates them, the accountable owner and the next valid action. The case closes only when the source system accepts the change and reruns the check.",
                "before": "A failed check lands in a worklist as a code that names the symptom. The processor works out the cause and the owner by hand, one system at a time.",
                "id": "causal-case",
                "title": "From queue codes to causal cases"
              },
              {
                "after": "Every release condition names its source and observation time. A material change expires the proposal and reopens only the affected checks. The payment system keeps final release control.",
                "before": "A payment candidate shows eligible. The approval was granted days ago, and the payee record, a hold or a screening result may have changed since.",
                "id": "dated-readiness",
                "title": "From a status badge to a dated decision"
              }
            ],
            "descriptor": "Invoice and payment readiness system of work",
            "firstWedge": "Start with one high-volume exception reason with a stable source rule and a named owner, such as a receipt or price mismatch, or one bounded pre-release gate where the evidence spans more than one system. Payment execution stays out of scope.",
            "functionLabel": "Invoicing & Payment (AP)",
            "id": "invoice-exception-payment-readiness",
            "modules": [
              {
                "id": "invoice-exception-triage",
                "name": "Invoice exception triage",
                "sourceStanding": "reference",
                "standing": "reference"
              },
              {
                "id": "payment-readiness",
                "name": "Payment readiness check",
                "sourceStanding": "pattern",
                "standing": "defined"
              },
              {
                "id": "invoice-intake-match",
                "name": "Invoice intake and matching",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "supplier-invoice-resolution",
                "name": "Supplier invoice resolution",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "payment-execution-guard",
                "name": "Payment execution control",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              }
            ],
            "name": "Clearway",
            "order": 7,
            "outcome": "A payment queue where every exception carries its records and its owner.",
            "proofClass": "demo-workblock",
            "proofQuestion": "Can one case show the causal evidence, the blockers, the owner and the next valid action, while the payment rail stays untouched?",
            "s2pRefs": [
              "groundworks-source:domain-workblock/invoice-exception-payment-readiness"
            ],
            "signature": "WORKABLE Clearway",
            "signatureStanding": "proposed",
            "slug": "clearway",
            "summary": "Classify invoice exceptions, collect the missing records and prepare decisions before payment execution."
          },
          {
            "changes": [
              {
                "after": "The review arrives as a decision package: every score opens into its method, sources and freshness, critical exceptions sit beside the average, and the proposed conclusion waits for the owner to accept, edit or reject it.",
                "before": "An analyst reconciles extracts into a workbook, the relationship manager builds a deck, and the reviewer still hunts for the source behind every disputed number.",
                "id": "decision-package",
                "title": "From scorecard to decision package"
              },
              {
                "after": "An action stays proposed until the responsible buyer or supplier owner accepts it. Closed means a named reviewer accepted the closure evidence; weak evidence reopens the action instead of erasing its history.",
                "before": "Actions live in minutes, decks and email threads. Done means someone ticked a task, and the next review starts by reconstructing what happened.",
                "id": "accepted-commitments",
                "title": "From minuted actions to accepted commitments"
              }
            ],
            "descriptor": "Supplier performance and innovation system of work",
            "firstWedge": "Start with one strategic supplier review cycle: one with heavy preparation, disputed evidence or actions that keep losing their owners.",
            "functionLabel": "Supplier Relationship Management (SRM)",
            "id": "supplier-performance-innovation-relationship",
            "modules": [
              {
                "id": "supplier-performance-review",
                "name": "Supplier performance review",
                "sourceStanding": "reference",
                "standing": "reference"
              },
              {
                "id": "supplier-innovation-pipeline",
                "name": "Supplier innovation pipeline",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "supplier-segmentation-governance",
                "name": "Supplier segmentation and governance",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "supplier-performance-monitor-correct",
                "name": "Supplier performance tracking and corrective action",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "supplier-relationship-joint-value",
                "name": "Supplier relationship and joint-value planning",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              }
            ],
            "name": "Alliance",
            "order": 8,
            "outcome": "Reviews end in commitments someone accepted, and the next review starts from what happened to them.",
            "proofClass": "demo-workblock",
            "proofQuestion": "Can one review finding be traced from its source evidence to an accepted commitment, its owner and the evidence that closed it?",
            "s2pRefs": [
              "groundworks-source:domain-workblock/supplier-performance-innovation-relationship"
            ],
            "signature": "WORKABLE Alliance",
            "signatureStanding": "proposed",
            "slug": "alliance",
            "summary": "Bring scorecards, actions, reviews and innovation opportunities into one accountable supplier rhythm."
          },
          {
            "changes": [
              {
                "after": "Every number opens the initiative behind it: source records, approved method, owner and current state. A challenged claim is answered from the case, not reassembled for the meeting.",
                "before": "A report shows pipeline, forecast and realised value. When finance challenges a number, an analyst rebuilds the calculation in a workbook and the meeting decides.",
                "id": "worked-case",
                "title": "From the savings report to the worked case"
              },
              {
                "after": "A material variance becomes one case that tests the normal explanations first, names the accountable owner, and stays open until the owning system accepts the action and the result is remeasured.",
                "before": "A dashboard flags a shortfall. Teams debate timing, volume, currency and adoption by email, and the action lands in another system with no link back to the case.",
                "id": "causal-case",
                "title": "From variance alerts to a causal case"
              }
            ],
            "descriptor": "Value realisation and savings system of work",
            "firstWedge": "Start with one initiative class where finance has already agreed the baseline and the recognition rule, and the actuals arrive from stable sources. Keep the planning, analytics and finance systems that hold authority today.",
            "functionLabel": "Savings & Value Realisation",
            "id": "value-realization-savings",
            "modules": [
              {
                "id": "savings-initiative",
                "name": "Savings initiative tracking",
                "sourceStanding": "reference",
                "standing": "reference"
              },
              {
                "id": "value-leakage-monitor",
                "name": "Value leakage monitoring",
                "sourceStanding": "pattern",
                "standing": "defined"
              },
              {
                "id": "value-opportunity-baseline",
                "name": "Value opportunity and baseline definition",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "realization-reconciliation-attribution",
                "name": "Value realisation reconciliation and attribution",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              },
              {
                "id": "value-portfolio-forecast",
                "name": "Value portfolio forecasting",
                "sourceStanding": "roadmap",
                "standing": "roadmap"
              }
            ],
            "name": "Value Hunter",
            "order": 9,
            "outcome": "A savings number finance can trace to the records that produced it.",
            "proofClass": "demo-workblock",
            "proofQuestion": "Can a reviewer tell why a number is pipeline, forecast or validated realisation, and open the initiatives and source records behind it?",
            "s2pRefs": [
              "groundworks-source:domain-workblock/value-realization-savings"
            ],
            "signature": "WORKABLE Value Hunter",
            "signatureStanding": "proposed",
            "slug": "value-hunter",
            "summary": "Connect opportunities, initiatives, forecasts, validation and leakage to the records that explain the number."
          }
        ],
        "disclosure": "public",
        "kind": "publication-content",
        "lifecycle": {
          "construct": "A Construct is the managed source of one product: its job and result, how the work happens and the standard it must meet.",
          "workblock": "A Workblock is the executable enterprise app assembled from a Construct, running under platform controls.",
          "world": "A World holds governed domain meaning: the Source-to-Pay identities, rules, evidence requirements and roles every product composes."
        },
        "moduleTotals": {
          "defined": 9,
          "reference": 8,
          "roadmap": 28
        },
        "ownerWorldId": "world:bw/product-foundation",
        "product": "WORKABLE",
        "proofClassRule": "demo-workblock when the Construct has at least one reference module; otherwise recipe. No Construct is claimed as a configured deployment or production evidence.",
        "schemaVersion": "workable.product-map/1",
        "sources": [
          {
            "commit": "20566e2824ffbca9527ceab6cfb6c19bb689d9a3",
            "path": "framework/generated/accenture-site.snapshot.json",
            "repository": "bwllaming/GroundWorks",
            "use": "domain Workblocks, module names and implementationStatus"
          },
          {
            "commit": "c33327a0275623483a38c9c874e525499f814494",
            "path": "workable/html/website/assets/portfolio.json",
            "repository": "bwllaming/brand-and-design",
            "use": "WORKABLE signatures, purpose, outcome, wedge, proof question, changes"
          }
        ],
        "standing": "proposed",
        "standingVocabulary": {
          "defined": "Business, data, authority and execution contracts are defined for client configuration. Source term: pattern.",
          "reference": "Demonstrable on the execution rails at the source's confirmed fidelity. Not proof of a customer deployment.",
          "roadmap": "Planned and not represented as running."
        },
        "worldId": "world:bw/product-foundation"
      }
    },
    {
      "id": "workable-site-expression/core",
      "sourceWorldId": "world:bw/product-foundation",
      "releaseId": "wr_8137e68f17239b473d1ec2226c05148391ec74678012aac48485f1b403be0b00",
      "entityId": "workable-site-expression/core",
      "contentDigest": "sha256:b5f5a370433ec405b69e2a8b9cd795b4fbffc8a8c56a0e7e43af738bdcf0dfd6",
      "disclosure": "public",
      "body": {
        "assets": [],
        "audience": "partner",
        "disclosure": "public",
        "edition": "core",
        "footer": {
          "credit": "A Beyond Labs release. Part of the Beyond Work family.",
          "tagline": "Goals. Realized."
        },
        "hero": {
          "creditLine": "A Beyond Labs release.",
          "eyebrow": "WORKABLE Core",
          "headline": "Build enterprise products\naround the work.",
          "lede": "WORKABLE is the product base partners use to deliver S2P enterprise apps. Nine Constructs. One shared model. Inspectable standing per module.",
          "primaryCta": {
            "href": "/accenture-edition",
            "label": "Build an edition"
          },
          "secondaryCta": {
            "href": "/constructs/value-hunter",
            "label": "See Value Hunter"
          }
        },
        "kind": "publication-content",
        "ownerWorldId": "world:bw/product-foundation",
        "product": "WORKABLE Core",
        "routes": {
          "constructDetail": "/constructs/:slug",
          "constructs": "/constructs",
          "root": "/"
        },
        "schemaVersion": "workable.site-expression/1",
        "sections": [
          {
            "body": "An edition changes more than the visual theme. It brings a named method into the work.",
            "id": "what-partners-get",
            "items": [
              {
                "body": "Nine stable product identities with defined behavior, evidence requirements and decision rules. You apply your method on top, not around them.",
                "id": "governed-constructs",
                "title": "Governed Constructs you adapt without forking."
              },
              {
                "body": "Take Core and contribute your method, vocabulary, roles and delivery knowledge. The Accenture Edition is the first published example.",
                "id": "edition-path",
                "title": "An edition path for your method and brand."
              },
              {
                "body": "Supplier, Contract, PurchaseOrder, Invoice and every domain relationship traced to one World. Configure for each client without owning the meaning.",
                "id": "shared-s2p-model",
                "title": "A shared S2P domain model."
              },
              {
                "body": "Each of the 45 Business modules carries its source standing: Reference, Defined or Roadmap. You see what is demonstrable and what is planned before you commit.",
                "id": "provable-standing",
                "title": "Provable standing per module."
              }
            ],
            "title": "The partner advantage."
          },
          {
            "body": "WORKABLE is built from a chain of governed sources, not from one application build.",
            "id": "lifecycle",
            "title": "World → Construct → Workblock."
          },
          {
            "body": "Each product covers one S2P responsibility and five Business modules at their actual source standing.",
            "id": "constructs",
            "standingLabels": {
              "defined": "Defined",
              "reference": "Demonstrable",
              "roadmap": "Roadmap"
            },
            "title": "Nine products. One model."
          },
          {
            "body": "Core is the shared foundation. A partner edition adds method, vocabulary, delivery knowledge and the partner's own brand. The Accenture Edition is the live example.",
            "cta": {
              "href": "/accenture-edition",
              "label": "See the Accenture Edition"
            },
            "id": "editions",
            "title": "Partners adapt Core without forking it."
          }
        ],
        "standing": "proposed",
        "worldId": "world:bw/product-foundation"
      }
    }
  ],
  "projectionDigest": "sha256:064b51f5d3e55081260200c6c9113b463c28820324843df777bd2ba32cf7993c"
}
